import { getClient } from "foundation-client";
import type { components } from "foundation-client/generated/schema";
import { captureException } from "lib/logger";

export type ArtChapter = components["schemas"]["ArtChapterSerializer"];

export async function getChapters(artId: number): Promise<ArtChapter[]> {
  const client = getClient();
  const chapters: ArtChapter[] = [];
  let after: string | null = null;

  try {
    do {
      const res = await client.GET("/api/arts/{art_id_or_slug}/chapters", {
        params: {
          path: { art_id_or_slug: artId },
          query: { limit: 100, ...(after ? { after } : {}) },
        },
      });

      const payload = res.data?.payload;
      chapters.push(...(payload?.data ?? []));
      const nextQuery = payload?.pagination?.next_page?.split("?")[1];
      after = nextQuery ? new URLSearchParams(nextQuery).get("after") : null;
    } while (after);
  } catch (error) {
    captureException(error as Error);
  }

  return chapters;
}
